export const en = {
  // Menu
  Home: "Home",
  HOME: "HOME",
  Services: "Services",
  SERVICES: "SERVICES",
  "SW Development": "SW Development",
  "SW DEVELOPMENT": "SW DEVELOPMENT",
  "IT Consultancy": "IT Consultancy",
  "IT CONSULTANCY": "IT CONSULTANCY",
  "Cloud Services": "Cloud Services",
  "CLOUD SERVICES": "CLOUD SERVICES",
  "Our Work": "Our Work",
  "OUR WORK": "OUR WORK",
  Experience: "Experience",
  EXPERIENCE: "EXPERIENCE",
  SKILLS: "SKILLS",
  Skills: "Skills",
  "About Us": "About Us",
  "ABOUT US": "ABOUT US",
  "About Toucan": "About Toucan",
  "ABOUT TOUCAN": "ABOUT TOUCAN",
  "Join Us!": "Join Us!",
  "JOIN US": "JOIN US",
  "Send CV": "Send CV",
  "SEND CV": "SEND CV",
  "Contact Us!": "Contact Us!",
  "CONTACT US!": "CONTACT US!",

  // Home
  "Fly even higher": "Fly even higher",
  Toucan: "Toucan",
  " is a team of senior software engineers who":
    " is a team of senior software engineers who",
  "enjoy looking for solutions.": "enjoy looking for solutions.",
  "We know that behind a challenging problem, there’ll be a great opportunity to develop new skills, to improve ourselves and to add value to our team.":
    "We know that behind a challenging problem, there’ll be a great opportunity to develop new skills, to improve ourselves and to add value to our team.",
  "We love teamwork": "We love teamwork",
  ", we enjoy spending some quality time with great professionals while we discover new technologies or tools.":
    ", we enjoy spending some quality time with great professionals while we discover new technologies or tools.",
  "Become your best self": "Become your best self",
  We: "We",
  "work with some of the most popular cloud-native technologies":
    "work with some of the most popular cloud-native technologies",
  "and we are always keeping up with the new stuff.":
    "and we are always keeping up with the new stuff.",
  "We work on projects that involves worldwide trend technologies that are changing our world.":
    "We work on projects that involves worldwide trend technologies that are changing our world.",
  "We are so excited about the future": "We are so excited about the future",
  ", and we want to be part of it.": ", and we want to be part of it.",
  "Join the teams that trust us": "Join the teams that trust us",
  SiteWhere: "SiteWhere",
  "50 Floor": "50 Floor",
  "More Info": "More Info",
  "We know about software": "We know about software",

  //SERVICES - sw development
  "Software Development": "Software Development",
  "We are": "We are",
  "engineers with 10 years of experience":
    "engineers with 10 years of experience",
  "in software development.": "in software development.",
  "We’ve got a": "We’ve got a",
  "consolidated team": "consolidated team",
  "of highly": "of highly",
  "committed, responsible and motivated":
    "committed, responsible and motivated",
  "professionals.": "professionals.",
  "We work": "We work",
  " hard to improve ourselves and": " hard to improve ourselves and",
  "to exceed customer expectations.": "to exceed customer expectations.",

  //SERVICES - IT consultancy
  "The skillset of our developers": "The skillset of our developers",
  "is the result of": "is the result of",
  "many years of experience working in many different technologies":
    "many years of experience working in many different technologies",
  "and projects.": "and projects.",
  "This makes it easy for us to catch up with your team very fast and to start":
    "This makes it easy for us to catch up with your team very fast and to start",
  "solving issues straight away": "solving issues straight away",
  "We are ready to help you.": "We are ready to help you.",
  "Temporary help in projects": "Temporary help in projects",
  "Get access to skilled workforce ready to assist your team to meet deadlines.":
    "Get access to skilled workforce ready to assist your team to meet deadlines.",
  "Adapt your current software systems to align with your new business goals.":
    "Adapt your current software systems to align with your new business goals.",
  "Get help specific tasks in the software development lifecycle (like analysis of user requirements, Risk Assessment, Testing and more).":
    "Get help with specific tasks of the software development lifecycle (like analysis of user requirements, Risk Assessment, Testing and more).",
  "SW Development Outsourcing": "SW Development Outsourcing",
  "Get more time to focus in your business and let us help you with your new Software Project.":
    "Get more time to focus in your business and let us help you with your new Software Project.",
  "Keep track of your project’s progress and check software evolution with quality metrics.":
    "Keep track of your project’s progress and check software evolution with quality metrics.",
  "Get a competitive advantage to your Company getting your project done faster and better, using the last technologies on the market.":
    "Get a competitive advantage to your Company getting your project done faster and better, using the last technologies on the market.",

  // SERVICES - Cloud Services
  Our: "Our",
  "Cloud Architects": "Cloud Architects",
  "are trained for planning and completing all aspects of a":
    "are trained for planning and completing all aspects of a",
  "successful migration process.": "successful migration process.",
  "We design, build, deploy and support":
    "We design, build, deploy and support",
  "scalable and high reliability": "scalable and high reliability ",
  "solutions.": "solutions.",
  "Let us guide you through a": "Let us guide you through a",
  "safe trip to the cloud.": "safe trip to the cloud.",
  "Assess your app’s current state": "Assess your app’s current state",
  "- Measure current performance levels.":
    "- Measure current performance levels.",
  "- Get a detailed cost of infrastructure.":
    "- Get a detailed cost of infrastructure.",
  "- Evaluate your software architecture.":
    "- Evaluate your software architecture.",
  "Define migration goals": "Define migration goals",
  "- Reduce costs of infrastructure": "- Reduce costs of infrastructure",
  "- Get access to enterprise-class technology fast":
    "- Get access to enterprise-class technology fast",
  "- Satisfy elastic business load": "- Satisfy elastic business load",
  "Create a migration strategy": "Create a migration strategy",
  "- Perform any necessary refactoring to your app’s code":
    "- Perform any necessary refactoring to your app’s code",
  "- Plan your data migration ": "- Plan your data migration ",
  "- Chose cloud configuration": "- Chose cloud configuration",
  "Get to work!": "Get to work!",

  // OUR WORK - Experience
  "Company dedicated to the manufacture and installation of floors.":
    "Company dedicated to the manufacture and installation of floors.",
  "It’s located in United States and has many branch offices.":
    "It’s located in United States and has many branch offices.",
  "We provide IT consulting services by making a team of highly-skilled developers available to the client who quickly joined their team and got started.":
    "We provide IT consulting services by making a team of highly-skilled developers available to the client who quickly joined their team and got started.",
  "Technologies used: Vue JS, Java, Kubernetes, Apache Kafka, Redis, PostgreSQL":
    "Technologies used: Vue JS, Java, Kubernetes, Apache Kafka, Redis, PostgreSQL",
  "Open Source IoT Platform which implements a micro services architecture.":
    "Open Source IoT Platform which implements a micro services architecture.",
  "This architecture uses gRPC as an internal communication mechanism, and it uses Apache Kafka and Redis to provide a highly performance process pipeline.":
    "This architecture uses gRPC as an internal communication mechanism, and it uses Apache Kafka and Redis to provide a highly performance process pipeline.",
  "This technology makes it possible to manage millions of devices and to process billions of events. SiteWhere is a highly scalable thanks to its micro services architecture, Kubernetes (for deployment) and Istio as Service Mesh. We provide IT consulting services by making a team of highly-skilled developers available to the client who helped solve problems and also recommended new approaches.":
    "This technology makes it possible to manage millions of devices and to process billions of events. SiteWhere is a highlyscalable thanks to its micro services architecture, Kubernetes (for deployment) and Istio as Service Mesh. We provide IT consulting services by making a team of highly-skilled developers available to the client who helped solve problems and also recommended new approaches.",
  "Technologies used: Java, kubernetes, MongoDB, PostgreSQL, Jaeger, Zookeeper, gRPC, MQTT, Apache Kafka, AWS, GKE, Google Cloud, Go.":
    "Technologies used: Java, kubernetes, MongoDB, PostgreSQL, Jaeger, Zookeeper, gRPC, MQTT, Apache Kafka, AWS, GKE, Google Cloud, Go.",
  "SiteWhere Enterprise Portal": "SiteWhere Enterprise Portal",
  "Website to sell SiteWhere Subscriptions.":
    "Website to sell SiteWhere Subscriptions.",
  "We started from a list of requirements from the client, we created a web design, we develop the frontend and the backend and we wrote unit test for both.":
    "We started from a list of requirements from the client, we created a web design, we develop the frontend and the backend and we wrote unit test for both.",
  "We used Spring Boot to create a REST API which implements a JWT HS256 service to provide authentication and authorization. We used Apache Zookeeper to provide resilience and reliability to the transactions. We also used WebSockets to improve the user experience in the website, for those events that required asynchronous confirmations.":
    "We used Spring Boot to create a REST API which implements a JWT HS256 service to provide authentication and authorization. We used Apache Zookeeper to provide resilience and reliability to the transactions. We also used WebSockets to improve the user experience in the website, for those events that required asynchronous confirmations.",
  "Tecnologies used: Vue JS, Vuetify, Sass, TypeScript, Chargify, Zendesk, Java, Rest, Apache Kafka, Kubernetes, PostgreSQL.":
    "Tecnologies used: Vue JS, Vuetify, Sass, TypeScript, Chargify, Zendesk, Java, Rest, Apache Kafka, Kubernetes, PostgreSQL.",
  Professionalism: "Professionalism",
  "The Toucan team has done an amazing job in helping to build the core SiteWhere technologies and our customer-facing commercial offerings. Their developers are highly-motivated, easy to work with, and perform well as a team. Many of their developers have multiple complimentary skill sets, allowing them to take on end-to-end development tasks that would often require a larger group. A truly impressive team!":
    "The Toucan team has done an amazing job in helping to build the core SiteWhere technologies and our customer-facing commercial offerings. Their developers are highly-motivated, easy to work with, and perform well as a team. Many of their developers have multiple complimentary skill sets, allowing them to take on end-to-end development tasks that would often require a larger group. A truly impressive team!",
  "Derek Adams": "Derek Adams",
  "Founder and Architect": "Founder and Architect",
  "SiteWhere Company": "SiteWhere Company",

  // OUR WORK - skills
  "Our skills": "Our skills",

  // ABOUT US - About Toucan
  "Where Toucan is born?": "Where Toucan is born?",
  "The Toucan Project started in Colonia Benitez, a little town near Resistencia City (Chaco, Argentina). Here, there’s an Educational Nature Reserve, which has 10 hectares and it’s kept as a restricted area, so only a few persons can get in with research, control and surveillance purposes. The main goal is to preserve the animals, the trees and the ecological processes. In the Reserve, there are 280 vegetable species, different mammals, and 135 birds species. However, there are animals that leave the reserve and walk around the town, so George usually see monkeys, coatis, and a lot of different birds like woodpecker and Toucans in the trees in his backyard.":
    "The Toucan Project started in Colonia Benitez, a little town near Resistencia City (Chaco, Argentina). Here, there’s an Educational Nature Reserve, which has 10 hectares and it’s kept as a restricted area, so only a few persons can get in with research, control and surveillance purposes. The main goal is to preserve the animals, the trees and the ecological processes. In the Reserve, there are 280 vegetable species, different mammals, and 135 birds species. However, there are animals that leave the reserve and walk around the town, so George usually see monkeys, coatis, and a lot of different birds like woodpecker and Toucans in the trees in his backyard.",
  "About the founder": "About the founder",
  "George is always fixing everything and he is a curious born. His passion about computers started when he was 16 years old, at high school, by the hand of the Computer Teacher. Which motivated him to become an Information Systems Engineer, and then to get a Ph. D. In Computer Science. In the meantime, he discover a new passion: teaching, so he’s also a teacher at the University.":
    "George is always fixing everything and he is a curious born. His passion about computers started when he was 16 years old, at high school, by the hand of the Computer Teacher. Which motivated him to become an Information Systems Engineer, and then to get a Ph. D. In Computer Science. In the meantime, he discover a new passion: teaching, so he’s also a teacher at the University.",
  "He’s work and life philosophy is ‘do it right, or don’t do it at all’, so every day, he works really hard to create the best software solution. But he can’t do it all by himself, so he has a great group of engineers who give their best at their job, and he fully trust them.":
    "He’s work and life philosophy is ‘do it right, or don’t do it at all’, so every day, he works really hard to create the best software solution. But he can’t do it all by himself, so he has a great group of engineers who give their best at their job, and he fully trust them.",
  "George’s life goal is to create a company known worldwide for its quality and reliable software and Toucan is his first step to achieve his dreams.":
    "George’s life goal is to create a company known worldwide for its quality and reliable software and Toucan is his first step to achieve his dreams.",

  // ABOUT US - join us
  "Our team": "About us",
  "We are a group of developers who enjoy new challenges. But we also love to have lunch together, trying new food, telling stories, and eatings desserts. We are all chocolate lovers! And we always have ice cream in our refrigerator. We enjoy our time together.":
    "We are a group of developers who enjoy new challenges. But we also love to have lunch together, trying new food, telling stories, and eatings desserts. We are all chocolate lovers! And we always have ice cream in our refrigerator. We enjoy our time together.",
  Teamwork: "Teamwork",
  "We enjoy learning new things": "We enjoy learning new things",
  "Positive attitude and Enthusiasm": "Positive attitude and Enthusiasm",
  "Strong work ethic": "Strong work ethic",
  "We help each other": "We help each other",
  "We look for the best solution": "We look for the best solution",
  Cooperation: "Cooperation",
  "Honesty and Integrity": "Honesty and Integrity",
  "We are motivated": "We are motivated",
  "We are creative": "We are creative",
  "What we offer": "What we offer",
  "We are in continuous growing so we always looking for a new talents. We know how important it is to be confortable at work, so we offer you:":
    "We are in continuous growing so we always looking for a new talents. We know how important it is to be confortable at work, so we offer you:",
  "Challenging project": "Challenging project",
  "Keeping up with the new stuff": "Keeping up with the new stuff",
  "Nice ergonomic chairs": "Nice ergonomic chairs",
  "Peaceful office": "Peaceful office",
  "What we need": "What we need",
  "Some of our current technical skills":
    "Some of our current technical skills",
  "Swift, SwiftUI, Android": "Swift, SwiftUI, Android",
  "Go, Python": "Go, Python",
  "Microsoft Azure": "Microsoft Azure",
  "Extra desirable skills": "Extra desirable skills",
  "English language": "English language",
  "Testing Skills": "Testing Skills",
  Jira: "Jira",
  Git: "Git",
  "Your Skills are not listed? Don’t worry! Get in touch! We’d love to hear about you!":
    "Your Skills are not listed? Don’t worry! Get in touch! We’d love to hear about you!",

  // ABOUT US - send CV
  "Send us your CV!": "Send us your CV!",
  "Your First Name:": "Your First Name:",
  "Your Last Name:": "Your Last Name:",
  "Your Mail:": "Your Mail:",
  "Tell us about you:": "Tell us about you:",
  "Your LinkedIn:": "Your LinkedIn:",
  Send: "Send",
  "Attach CV": "Attach CV",

  // Contact us
  "Get in Touch!": "Get in Touch!",
  "Company Name:": "Company Name:",
  "Your Idea:": "Your Idea:",
  "Thanks!": "Gracias!",
  "Please try again.": "Please try again.",
  Back: "Back",

  // Footer
  Contact: "Contact",
  "Us!": "Us!",
  Find: "Find",
  Here: "Here",
  "We are!": "We are!",
  "López y Planes 290": "López y Planes 290",
  "Resistencia, Chaco": "Resistencia, Chaco",
  Argentina: "Argentina",
  "contact@toucansoft.io": "contact@toucansoft.io",
  "Write Us": "Write Us",
  "+54 9 362 4187441": "+54 9 362 4187441",
  "Toucan, All Rights Reserved": "Toucan, All Rights Reserved",
};
